const vi = {
  header: {
    search: "Tìm kiếm",
    downloadApp: "Tải ứng dụng"
  },

  common: {
    next: "Tiếp Theo",
    previous: "Trước",
    comingsoon: "Nội dung sẽ được chúng tôi cập nhật sớm nhất.",
    pageTitle: "GoPaperless Agent | Công ty Cổ phần Quantera",
  },

  sidebar: {
    welcome: "Chào mừng",
    version: "Phiên bản",

    install: {
      title: "Hướng dẫn cài đặt",
      itemInstall: "Cài đặt GoPaperless Agent",
      itemUninstall: "Gỡ cài đặt GoPaperless Agent",
      itemGuideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS: "Tin cậy các nhà CA công cộng trên macOS"
    },

    usage: {
      title: "Hướng dẫn sử dụng",
      config: "Cấu hình GoPaperless Agent",
      login: "Đăng nhập GoPaperless Agent",
      viewCert: "Xem chứng thư số cá nhân",
      messageBox: "Dịch vụ MessageBox",
      supportedSign: "Hỗ trợ xác thực ký số qua VNeID"
    },

    cases: {
      title: "Trường hợp sử dụng",
      word: "Ký bằng Microsoft Word",
      excel: "Ký bằng Microsoft Excel",
      powerPoint: "Ký bằng Microsoft PowerPoint",
      outlook: "Ký bằng Microsoft Outlook",
      foxit: "Ký bằng Foxit Reader",
      pdfSign: "Ký bằng PDF Sign",
      acrobatReader: "Ký bằng Acrobat Reader",
      acrobatWriter: "Ký bằng Acrobat Writer"
    },

    pricing: "Bảng giá"
  },

  footer: {
    powered: "Được phát triển bởi Mobile-ID"
  },

  copy: {
    copy: "Sao chép",
    copied: "Đã sao chép"
  },

  // ⭐ Thêm phần WELCOME
  welcome: {
    title: "Welcome",
    lastUpdatedBase: "Cập nhật lần cuối",

    intro: {
      p1: "GoPaperless Agent – phát triển bởi Mobile-ID - là giải pháp trung gian giúp ký số an toàn và quản lý chứng thư thông minh dựa trên VNeID. Các lợi thế kỹ thuật mạnh mẽ như hỗ trợ đa CA, tích hợp Adobe/Office và quy trình tự động hóa vòng đời chứng thư giúp sản phẩm có khả năng chiếm lĩnh thị trường Thương mại điện tử và chứng thư số tại Việt Nam.",
      p2: "Thay thế nhu cầu về phần cứng cục bộ như thẻ thông minh và USB Token nhưng không thay đổi trải nghiệm người dùng.",
      p3: "Người dùng có thể ký bất kỳ tài liệu/tệp nào trực tiếp trong ứng dụng kinh doanh của họ mà không cần tải lên dịch vụ được lưu trữ. Ngoài ra, định dạng tệp ứng dụng được giữ lại sau quá trình ký. Điều này có nghĩa là không tự động chuyển đổi sang PDF hoặc các định dạng khác."
    },

    techOverview: {
      title: "Tổng quan kỹ thuật",

      architecture: {
        title: "Kiến trúc hệ thống",
        item1: "GoPaperless Agent hoạt động như lớp trung gian, kết nối an toàn giữa VNeID, các CA ký số từ xa và ứng dụng bên ngoài. Kiến trúc gồm:",
        item2: "API Gateway: hỗ trợ RESTful APIs kết nối với VNeID & nhiều CA như VNPT, Viettel, FPT.",
        item3: "Module xác thực: sử dụng mức VNeID Level 2 (OTP, sinh trắc học).",
        item4: "Signing Engine: triển khai chuẩn mã hóa RSA/ECC theo quy định Việt Nam.",
        item5: "Lớp tích hợp ứng dụng: ký trực tiếp trong Adobe, MS Office, hệ thống thuế/hải quan.",
        item6: "Quản lý vòng đời chứng thư: tự động cấp mới, gia hạn, thu hồi."
      }
    },

    features: {
      title: "Các tính năng chính",
      item1: "Tích hợp VNeID – xác thực và ký số trong 1 bước.",
      item2: "Hỗ trợ đa CA ký số từ xa.",
      item3: "Ký trực tiếp trong Adobe, Word, Excel, hệ thống nghiệp vụ.",
      item4: "Tự động hóa vòng đời chứng thư.",
      item5: "Tuân thủ ISO 27001 và quy định ATTT Việt Nam.",
      item6: "Giao diện người dùng trực quan."
    },

    download: {
      description: "Trải nghiệm demo GoPaperless Agent để xem quy trình ký số từ xa hoạt động ngay trong ứng dụng của bạn.",
      description2: "Ứng dụng GoPaperless Agent phát hành trên Windows Store, App Store. Hãy chọn hệ điều hành Windows hoặc macOS mà bạn cần tải về."
    },

    next: {
      title: "Tiếp theo",
      version: "Phiên bản"
    },

    lastUpdated: "Cập nhật lần cuối 1 tháng trước"
  },

  cookies: {
    title: "Trang web này sử dụng cookie",
    description: 'Bằng cách xác nhận "Chấp nhận Tất cả", bạn đồng ý cho phép lưu trữ cookie trên thiết bị của mình nhằm cải thiện khả năng điều hướng trang web, phân tích việc sử dụng trang và hỗ trợ các hoạt động tiếp thị của chúng tôi.',
    preferences: "Tùy chọn cookie",
    rejectAll: "Từ chối Tất cả",
    acceptAll: "Chấp nhận Tất cả",

    preferencesTitle: "Thiết lập cookie tùy chọn",
    strictlyNecessary: "Cookie bắt buộc",
    strictlyNecessaryDesc: "Những cookie này cần thiết để trang web hoạt động đúng cách. Chúng không thu thập dữ liệu cho mục đích quảng cáo và không thể tắt đi, vì điều đó sẽ làm gián đoạn các chức năng cơ bản của trang web.",
    alwaysActive: "Luôn hoạt động",

    functional: "Cookie chức năng / Tùy chọn",
    functionalDesc: "Những cookie này ghi nhớ các lựa chọn và cài đặt của bạn để mang lại trải nghiệm cá nhân hóa hơn, chẳng hạn như ngôn ngữ đã chọn, chế độ sáng/tối, cỡ chữ, khu vực hoặc các tùy chỉnh khác.",

    analytics: "Cookie phân tích / Hiệu suất",
    analyticsDesc: "Những cookie này giúp chúng tôi hiểu cách người dùng tương tác với trang web. Toàn bộ dữ liệu đều được ẩn danh hoàn toàn và chỉ dùng để cải thiện hiệu suất trang web, tốc độ tải trang và chất lượng nội dung – không nhận dạng cá nhân.",

    marketing: "Cookie quảng cáo / Tiếp thị",
    marketingDesc: "Những cookie này cho phép chúng tôi hiển thị quảng cáo phù hợp hơn với sở thích của bạn trên trang web của chúng tôi và các nền tảng khác. Chúng theo dõi hành vi duyệt web một cách ẩn danh và ngăn chặn việc hiển thị cùng một quảng cáo lặp lại nhiều lần.",

    savePreferences: "Lưu thiết lập",
    cancel: "Hủy"
  },

  installationGuide: {
    operatingsystemrequire: "Yêu cầu hệ thống:",
    operatingsystem: "Hệ điều hành: Windows 8 trở lên (Windows 8/10/11, hỗ trợ 32-bit và 64-bit), macOS 10.15 trở lên",
    adminstrator: "Quyền cài đặt phần mềm (Administrator)",
    internet: "Kết nối Internet ổn định",
    step: "Các bước tải:",
    step1: "<strong>Bước 1:</strong> Truy cập đường dẫn cài đặt:",
    step2: "<strong>Bước 2:</strong> Tại trang cài đặt, lựa chọn phiên bản phù hợp với hệ điều hành đang sử dụng:",
    step3: "<strong>Bước 3:</strong> Nhấn chọn phiên bản tương ứng để tải tệp cài đặt về máy tính.\nTệp cài đặt sẽ được lưu trong thư mục tải xuống mặc định trên thiết bị.",
    step2a: "GoPaperless Agent – Windows (dành cho hệ điều hành Windows 8 trở lên) ",
    step2b: "GoPaperless Agent – macOS (dành cho hệ điều hành macOS 10.15 trở lên) ",
  },

  installationGopaperlessAgent: {
    stepinstall: "Các bước tải và cài đặt:",
    step1: "<strong>Bước 1:</strong> Mở thư mục chứa tệp cài đặt đã tải về trên máy tính. ",
    step2: "<strong>Bước 2:</strong> Nhấp đúp chuột vào tệp <strong>GoPaperlessAgentInstaller.exe</strong> để bắt đầu cài đặt. ",
    step3: "<strong>Bước 3:</strong> Khi hệ thống hiển thị thông báo bảo mật (User Account Control), chọn <strong>Yes</strong> để cho phép ứng dụng thực hiện cài đặt.",
    step4: "<strong>Bước 4:</strong> Hệ thống hiển thị thông báo chào mừng và hướng dẫn cài đặt. Nhấn nút <strong>Next ></strong> để tiếp tục quá trình cài đặt. ",
    step5:"<strong>Bước 5:</strong> Đọc nội dung điều khoản sử dụng (License Agreement). Tích chọn vào ô <strong>☑ I accept the terms of the License Agreement</strong>.",
    step6:"<strong>Bước 6:</strong> Nhấn nút <strong>Install</strong> để tiếp tục. ",
    todo: "Lưu ý trong quá trình cài đặt: ",
    todo1: "Chờ hệ thống hoàn tất quá trình cài đặt. ",
    todo2: "Không tắt cửa sổ cài đặt trong quá trình này. ",
    todo3: "Không tắt máy hoặc khởi động lại máy tính khi chưa hoàn tất. ",
    todotime: "Thời gian cài đặt có thể mất vài giây đến vài phút tùy theo cấu hình máy tính. ",
    note: "Lưu ý: ",
    note1: "Nếu quá trình cài đặt bị gián đoạn, vui lòng thực hiện lại từ đầu. ",
    note2: "Trong trường hợp xảy ra lỗi, kiểm tra quyền Administrator hoặc khởi động lại máy và thử lại. ",
    step7: "<strong>Bước 7:</strong> Nhấn nút <strong>Finish</strong> để kết thúc quá trình cài đặt. Sau khi nhấn <strong>Finish</strong>, hệ thống sẽ tự động khởi chạy ứng dụng <strong>GoPaperless Agent</strong>. ",
    completeclient: "Giao diện sau khi cài đặt hoàn tất sẽ hiển thị như hình bên dưới. ",
  },

  guideToAddingandTrustingDigitalCertificatesFromCAsOnMacOS: {
    step1: "<strong>Bước 1:</strong> Mở Tùy chọn Hệ thống của hệ điều hành và nhấn nút <strong>Cấu hình</strong>.",
    step2: "<strong>Bước 2:</strong> Chọn cấu hình có tên là <strong>GoPaperless Agent Cert</strong> và sau đó nhấn nút <strong>Cài đặt</strong>.",
    step3: "<strong>Bước 3:</strong> Nhấn nút <strong>Cài đặt</strong> lần nữa để xác nhận thực hiện cài đặt.",
    step4: "<strong>Bước 4:</strong> Nhập mật khẩu của máy tính. ",
    step5: "Sau khi nhập mật khẩu xong, hệ điều hành sẽ tự động thêm chứng thư số của các nhà CA vô Keychain và tin cậy các chứng thư số đã được thêm vào Keychain.",
  },

  uninstallationGopaperlessAgent: {
    step1: "<strong>Bước 1:</strong> Đóng ứng dụng <strong>GoPaperless Agent</strong> (nếu đang mở).",
    step2: "<strong>Bước 2:</strong> Nhấn <strong>Start → mở Control Panel.</strong>",
    step3: "<strong>Bước 3:</strong> Chọn <strong>Programs → Programs and Features.</strong>",
    step4: "<strong>Bước 4:</strong> Trong danh sách chương trình đã cài đặt, chọn <strong>GoPaperless Agent</strong>.",
    step5: "<strong>Bước 5:</strong> Nhấp chuột phải và chọn <strong>Uninstall/Change.</strong>",
    step6: "<strong>Bước 6:</strong> Khi hệ thống hiển thị thông báo xác nhận, chọn <strong>Yes</strong> để tiến hành gỡ cài đặt.",
    step7: "<strong>Bước 7:</strong> Tại màn hình <strong>Welcome – GoPaperless Agent Setup (Uninstall)</strong>, nhấn <strong>Next</strong> để tiếp tục.",
    step8: "<strong>Bước 8:</strong> Tại màn hình chọn đường dẫn cài đặt (Installation Folder), nhấn <strong>Uninstall</strong> để bắt đầu quá trình gỡ cài đặt.",
    step9: "<strong>Bước 9:</strong> Chờ hệ thống hoàn tất quá trình gỡ cài đặt.",
    step10: "<strong>Bước 10:</strong> Sau khi hoàn tất, nhấn Finish (nếu có) để kết thúc.",
  },

  loginGopaperlessAgent: {
    loginMobileID: "<strong>1. Đăng nhập bằng Mobile-ID</strong>",
    loginMobileIDstep1: "<strong>Bước 1:</strong> Chọn phương thức đăng nhập",
    loginMobileIDstep1sub: "Tại màn hình đăng nhập, nhấn nút <strong>Đăng nhập với Mobile-ID</strong>",
    loginMobileIDstep2: "<strong>Bước 2:</strong> Nhập thông tin tài khoản",
    loginMobileIDstep2sub: "Người dùng nhập:",
    loginMobileIDstep2sub1: "Tên đăng nhập hoặc Email",
    loginMobileIDstep2sub2: "Mật khẩu",
    loginMobileIDstep2sub3: "Sau đó nhấn nút <strong>Đăng nhập</strong>",
    loginMobileIDstep3: "<strong>Bước 3:</strong> Đăng nhập thành công",
    loginMobileIDstep3sub: "Nếu thông tin hợp lệ, hệ thống sẽ đăng nhập thành công và hiển thị: Giao diện Quản lý chứng thư số",
    loginMobileIDstep3sub1: "Giao diện Quản lý chứng thư số",
    loginMobileIDstep3sub2: "Tại đây, người dùng có thể:",
    loginMobileIDstep3sub2item1: "Xem danh sách chứng thư số",
    loginMobileIDstep3sub2item2: "Thêm chứng thư mới",
    loginMobileIDstep3sub2item3: "Xem lịch sử ký",
    loginMobileIDstep3sub2item4: "Quản lý thông tin chứng thư",

    loginGoogle: "<strong>2. Đăng nhập qua Google</strong>",
    loginGoogleStep1: "<strong>Bước 1:</strong> Chọn phương thức đăng nhập",
    loginGoogleStep1sub: "Tại màn hình đăng nhập, nhấn nút <strong>Đăng nhập với Google</strong>",
    loginGoogleStep2: "<strong>Bước 2:</strong> Chọn tài khoản Google",
    loginGoogleStep2sub: "Hệ thống sẽ chuyển sang màn hình đăng nhập Google.",
    loginGoogleStep2subitem1: "Chọn tài khoản Google mà bạn muốn sử dụng \n hoặc",
    loginGoogleStep2subitem2: "Nhập Email Google và mật khẩu (nếu chưa đăng nhập)",

    loginVNeID: "<strong>3. Đăng nhập qua VNeID</strong>",
    loginVNeIDStep1: "<strong>Bước 1:</strong> Chọn phương thức đăng nhập",
    loginVNeIDStep1sub: "Tại màn hình đăng nhập của ứng dụng, nhấn: <strong>Đăng nhập với VNeID</strong>",
    loginVNeIDStep2: "<strong>Bước 2:</strong> Màn hình Cổng Dịch vụ công / Cổng thông tin quốc gia",
    loginVNeIDStep2sub: "Hệ thống sẽ chuyển sang màn hình đăng nhập của Cổng thông tin quốc gia.",
    loginVNeIDStep2sub1: "Tại đây có 2 phương thức đăng nhập:",
    loginVNeIDStep2sub1item1: "Đăng nhập bằng Số định danh cá nhân và Mật khẩu",
    loginVNeIDStep2sub1item2: "Đăng nhập bằng quét mã QR bằng ứng dụng VNeID",
    loginVNeIDStep2sub2: "Trong tài liệu này minh họa theo phương thức Quét mã QR.",
    loginVNeIDStep3: "<strong>Bước 3:</strong> Quét mã QR bằng ứng dụng VNeID",
    loginVNeIDStep3sub: "Thực hiện như sau:",
    loginVNeIDStep3subitem1: "Mở ứng dụng VNeID trên điện thoại.",
    loginVNeIDStep3subitem2: "Chọn chức năng Quét mã QR.",
    loginVNeIDStep3subitem3: "Quét mã QR hiển thị trên màn hình máy tính.",
    loginVNeIDStep3subitem4: "Xác nhận đăng nhập trên ứng dụng VNeID (nếu được yêu cầu).",
    loginVNeIStep4: "<strong>Bước 4:</strong> Đăng nhập thành công",
  },

  viewPDC: {
    description:"Sau khi đăng nhập GoPaperless Agent, hệ thống sẽ tự động tải các chứng thư số trên máy chủ vào Windows Keystore để thực hiện ký số. Người dùng có thể xem và làm mới danh sách chứng thư số khi cần.",
    description1: "Xem chứng thư số cá nhân",
    description2: "Người dùng cần đăng nhập vào <strong>GoPaperless Agent</strong>, sau đó mở ứng dụng từ <strong>System Tray</strong> bằng cách nhấp vào biểu tượng <strong>GoPaperless Agent</strong> và chọn menu <strong>GoPaperless Agent</strong>.",
    description3: "Nhấp đúp vào bất kỳ <strong>chứng thư số</strong> nào để xem chi tiết. <strong>GoPaperless Agent</strong> sử dụng <strong>trình xem chứng thư số mặc định của Windows</strong> để hiển thị thông tin chi tiết của chứng thư số.",
    description4: "Nhấn <strong>Làm mới (Refresh)</strong> để tải các <strong>chứng thư số mới</strong> từ máy chủ.",
  },

  supportedSign: {
    description: "Tính năng hỗ trợ ký xác thực qua ứng dụng VNeID cho phép bạn thực hiện ký số tài liệu thông qua xác thực danh tính điện tử.",
    stepbystep: "<strong>Quy trình thực hiện như sau:</strong>",
    step1: "<strong>Khởi tạo vị trí</strong> ký và thiết lập nội dung hiển thị chữ ký trên tài liệu.",
    step2: "Nhấn <strong>Ký</strong> để bắt đầu quá trình xác thực.",
    step3: "Hệ thống sẽ hiển thị <strong>cửa sổ chờ ký</strong> và đồng thời gửi yêu cầu xác nhận ký số đến ứng dụng VNeID trên thiết bị của bạn.",
    step4: "Bạn thực hiện <strong>xác thực trên ứng dụng VNeID</strong> theo hướng dẫn (ví dụ: xác thực sinh trắc học hoặc mã PIN).",
    step5: "Sau khi xác thực thành công, <strong>chữ ký số sẽ được đóng xuống tài liệu<strong> và hoàn tất quá trình ký.",
    description2: "Tính năng này đảm bảo tính pháp lý, an toàn và xác thực đúng danh tính người ký."
  },

  InstallationGuide:{
    description: "<strong>GoPaperless Agent</strong> là một tiện ích (plug-in) nhẹ dành cho hệ điều hành Microsoft Windows và Apple macOS, cho phép ký số từ xa đối với tài liệu, email và các định dạng dữ liệu khác (ký số dựa trên máy chủ – server-based signatures). Giải pháp này loại bỏ nhu cầu sử dụng smart card hoặc USB Token cho người dùng cuối. Thay vào đó, khóa ký và chứng thư số của người dùng được quản lý tập trung trong hệ thống Trusted Hub Service Provider Appliance.",
    description1: "Người dùng có thể ký số trực tiếp trên bất kỳ ứng dụng nào chạy trên Windows hoặc macOS mà không làm thay đổi trải nghiệm sử dụng ban đầu của ứng dụng.",
    description2: "Nhờ đó, GoPaperless Agent giúp giảm chi phí triển khai, đồng thời mang lại trải nghiệm ký số tiện lợi và thân thiện hơn.",
  },

  messageBox: {
    error: "<strong>Thông báo quan trọng</strong>",
    errorItem1: "Liên quan đến từ chối ký, lỗi, sự cố hoặc vấn đề cần xử lý ngay.",
    errorItem2: "Có thể ảnh hưởng đến giao dịch, ký số hoặc bảo mật tài khoản.",
    errorItem3: "Người dùng nên kiểm tra và thực hiện hành động khắc phục.",

    warning: "<strong>Thông báo Cảnh báo / Nhắc nhở</strong>",
    warningItem1: "Mang tính cảnh báo hoặc nhắc nhở (ví dụ: sắp hết hạn, cần cập nhật thông tin).",
    warningItem2: "Không phải lỗi nghiêm trọng nhưng cần lưu ý để tránh gián đoạn dịch vụ.",

    ok: "<strong>Thông báo thành công / Xác nhận</strong>",
    okItem1: "Xác nhận thao tác đã thực hiện thành công (ví dụ: ký thành công, cập nhật thành công).",
    okItem2: "Hoặc thông báo trạng thái hệ thống đang hoạt động bình thường."
  },

  word: {
    step1: "<strong>Bước 1:</strong> Mở tài liệu cần ký",
    step1a: "Mở Microsoft Word.",
    step1b: "Tạo tệp dữ liệu mới hoặc mở tệp dữ liệu có sẵn cần ký.",

    step2: "<strong>Bước 2:</strong> Chọn <strong>File → Info</strong>.",

    step3: "<strong>Bước 3:</strong> Chọn <strong>Protect Document</strong>.",

    step4: "<strong>Bước 4:</strong> Chọn <strong>Add a Digital Signature</strong>.",

    step5: "<strong>Bước 5:</strong> Kiểm tra chứng thư số (CTS) đang hiển thị có đúng CTS mà bạn muốn dùng để ký hay không?.",

    step6: "<strong>Bước 6:</strong> Nếu muốn thay đổi CTS, chọn <strong>Change</strong>.",

    step7: "<strong>Bước 7:</strong> Bấm <strong>Sign</strong> để bắt đầu ký",

    step8: "<strong>Bước 8:</strong> Màn hình chờ xác thực sẽ xuất hiện.",

    step9: "<strong>Bước 9:</strong> Mở ứng dụng VNeID trên thiết bị di động.",
    step9a: "Vào mục <strong>Thông báo</strong> → Chọn <strong>Thông báo xác nhận yêu cầu ký số.</strong>",
    step9b: "Kiểm tra thông tin.",
    step9c: "Tích chọn nội dung đồng ý:",
    step9d: "“Tôi đã đọc và hiểu rõ nội dung mục đích (đã nêu ở trên); quyền và nghĩa vụ của chủ thể dữ liệu và đồng ý với các nội dung này.”",
    step9e: "Nhấn <strong>Xác nhận chia sẻ</strong>.",
    step9f: "Ứng dụng hiển thị <strong>Chia sẻ thông tin thành công.</strong>",

    step10: "<strong>Bước 10:</strong> Hoàn tất ký số",
    step10a: "Hệ thống GoPaperless Agent hiển thị thông báo: \n <strong>“Thực hiện ký thành công.”</strong>",

    step11: "<strong>Bước 11:</strong> Kiểm tra tài liệu đã ký. Chọn <strong>Signed Document</strong> để mở tài liệu đã ký.",

    step12: "<strong>Bước 12:</strong> Tại bảng <strong>Signature</strong> (bên phải màn hình), xem thông tin chữ ký.",
    step12des: "Nếu muốn xem chi tiết chứng thư số (CTS):",

    step12a: "Nhấn <strong>biểu tượng mở rộng</strong>",
    step12b: "Chọn <strong>Signature Details</strong>",
    step12c: "Nhấn <strong>View</strong> để xem chi tiết",
    step12d: "Nhấn <strong>OK</strong> để hoàn tất"
  },

  excel: {
    step1: "<strong>Bước 1:</strong> Mở tài liệu cần ký",
    step1a: "Mở Microsoft Excel.",
    step1b: "Tạo tệp dữ liệu mới hoặc mở tệp dữ liệu có sẵn cần ký.",

    step2: "<strong>Bước 2:</strong> Chọn <strong>File → Info</strong>.",

    step3: "<strong>Bước 3:</strong> Chọn <strong>Protect Workbook</strong>.",

    step4: "<strong>Bước 4:</strong> Chọn <strong>Add a Digital Signature</strong>.",

    step5: "<strong>Bước 5:</strong> Kiểm tra chứng thư số (CTS) đang hiển thị có đúng CTS mà bạn muốn dùng để ký hay không?.",

    step6: "<strong>Bước 6:</strong> Nếu muốn thay đổi CTS, chọn <strong>Change</strong>.",

    step7: "<strong>Bước 7:</strong> Bấm <strong>Sign</strong> để bắt đầu ký",

    step8: "<strong>Bước 8:</strong> Màn hình chờ xác thực sẽ xuất hiện.",

    step9: "<strong>Bước 9:</strong> Mở ứng dụng VNeID trên thiết bị di động.",
    step9a: "Vào mục <strong>Thông báo</strong> → Chọn <strong>Thông báo xác nhận yêu cầu ký số.</strong>",
    step9b: "Kiểm tra thông tin.",
    step9c: "Tích chọn nội dung đồng ý:",
    step9d: "“Tôi đã đọc và hiểu rõ nội dung mục đích (đã nêu ở trên); quyền và nghĩa vụ của chủ thể dữ liệu và đồng ý với các nội dung này.”",
    step9e: "Nhấn <strong>Xác nhận chia sẻ</strong>.",
    step9f: "Ứng dụng hiển thị <strong>Chia sẻ thông tin thành công.</strong>",

    step10: "<strong>Bước 10:</strong> Hoàn tất ký số",
    step10a: "Hệ thống GoPaperless Agent hiển thị thông báo: \n <strong>“Thực hiện ký thành công.”</strong>",

    step11: "<strong>Bước 11:</strong> Kiểm tra tài liệu đã ký. Chọn <strong>Signed Workbook</strong> để mở tài liệu đã ký.",

    step12: "<strong>Bước 12:</strong> Tại bảng <strong>Signature</strong> (bên phải màn hình), xem thông tin chữ ký.",
    step12des: "Nếu muốn xem chi tiết chứng thư số (CTS):",

    step12a: "Nhấn <strong>biểu tượng mở rộng</strong>",
    step12b: "Chọn <strong>Signature Details</strong>",
    step12c: "Nhấn <strong>View</strong> để xem chi tiết",
    step12d: "Nhấn <strong>OK</strong> để hoàn tất"
  },

  ppt: {
    step1: "<strong>Bước 1:</strong> Mở tài liệu cần ký",
    step1a: "Mở Microsoft PowerPoint.",
    step1b: "Tạo tệp dữ liệu mới hoặc mở tệp dữ liệu có sẵn cần ký.",

    step2: "<strong>Bước 2:</strong> Chọn <strong>File → Info</strong>.",

    step3: "<strong>Bước 3:</strong> Chọn <strong>Protect Resentation</strong>.",

    step4: "<strong>Bước 4:</strong> Chọn <strong>Add a Digital Signature</strong>.",

    step5: "<strong>Bước 5:</strong> Kiểm tra chứng thư số (CTS) đang hiển thị có đúng CTS mà bạn muốn dùng để ký hay không?.",
    
    step6: "<strong>Bước 6:</strong> Nếu muốn thay đổi CTS, chọn <strong>Change</strong>.",

    step7: "<strong>Bước 7:</strong> Bấm <strong>Sign</strong> để bắt đầu ký",

    step8: "<strong>Bước 8:</strong> Màn hình chờ xác thực sẽ xuất hiện.",

    step9: "<strong>Bước 9:</strong> Mở ứng dụng VNeID trên thiết bị di động.",
    step9a: "Vào mục <strong>Thông báo</strong> → Chọn <strong>Thông báo xác nhận yêu cầu ký số.</strong>",
    step9b: "Kiểm tra thông tin.",
    step9c: "Tích chọn nội dung đồng ý:",
    step9d: "“Tôi đã đọc và hiểu rõ nội dung mục đích (đã nêu ở trên); quyền và nghĩa vụ của chủ thể dữ liệu và đồng ý với các nội dung này.”",
    step9e: "Nhấn <strong>Xác nhận chia sẻ</strong>.",
    step9f: "Ứng dụng hiển thị <strong>Chia sẻ thông tin thành công.</strong>",

    step10: "<strong>Bước 10:</strong> Hoàn tất ký số",
    step10a: "Hệ thống GoPaperless Agent hiển thị thông báo: \n <strong>“Thực hiện ký thành công.”</strong>",

    step11: "<strong>Bước 11:</strong> Kiểm tra tài liệu đã ký. Chọn <strong>Signed Presentation</strong> để mở tài liệu đã ký.",

    step12: "<strong>Bước 12:</strong> Tại bảng <strong>Signature</strong> (bên phải màn hình), xem thông tin chữ ký.",
    step12des: "Nếu muốn xem chi tiết chứng thư số (CTS):",

    step12a: "Nhấn <strong>biểu tượng mở rộng</strong>",
    step12b: "Chọn <strong>Signature Details</strong>",
    step12c: "Nhấn <strong>View</strong> để xem chi tiết",
    step12d: "Nhấn <strong>OK</strong> để hoàn tất"
  },

  foxit: {
    step1: "<strong>Bước 1:</strong> Mở tài liệu cần ký",
    step1a: "Mở Foxit PDF Reader.",
    step1b: "Tạo tệp dữ liệu mới hoặc mở tệp dữ liệu có sẵn cần ký.",

    step2: "<strong>Bước 2:</strong> Chọn <strong>Protect</strong> trên thanh công cụ.",

    step3: "<strong>Bước 3:</strong> Chọn <strong>Sign & Certify</strong> . Sau đó chọn <strong>Place Signature....</strong>",

    step4: "<strong>Bước 4:</strong> Đưa con trỏ chuột vào vùng PDF, nhấn giữ chuột trái để tạo khung hiển thị chữ ký số.",

    step5: "<strong>Bước 5:</strong> Kiểm tra chứng thư số đúng chứng thư mà bạn muốn ký hay chưa? Nếu đúng, bấm <strong>Sign</strong> để bắt đầu Ký.",

    step6: "<strong>Bước 6:</strong> Giao diện hiển thị chờ Xác thực ký số từ ứng dụng VNeID",

    step7: "<strong>Bước 7:</strong> Mở ứng dụng VNeID trên thiết bị di động.",
    step7a: "Vào mục <strong>Thông báo</strong> → Chọn <strong>Thông báo xác nhận yêu cầu ký số.</strong>",
    step7b: "Kiểm tra thông tin.",
    step7c: "Tích chọn nội dung đồng ý:",
    step7d: "“Tôi đã đọc và hiểu rõ nội dung mục đích (đã nêu ở trên); quyền và nghĩa vụ của chủ thể dữ liệu và đồng ý với các nội dung này.”",
    step7e: "Nhấn <strong>Xác nhận chia sẻ</strong>.",
    step7f: "Ứng dụng hiển thị <strong>Chia sẻ thông tin thành công.</strong>",

    step8: "<strong>Bước 8:</strong> Hoàn tất ký số",
    step8a: "Hệ thống GoPaperless Agent hiển thị thông báo: \n <strong>“Thực hiện ký thành công.”</strong>",

    step9: "<strong>Bước 9:</strong> Tại tài liệu đã ký, <strong>nhấn đúp (double-click) vào chữ ký số</strong> trên tài liệu.",

    step10: "<strong>Bước 10:</strong> Cửa sổ <strong>Signature Validation Status</strong> sẽ hiển thị. Chọn <strong>Signature Properties...</strong>",

    step11: "<strong>Bước 11:</strong> Tại cửa sổ <strong>Signature Properties</strong>, bấm <strong>Show Certificate</strong>. Sẽ hiển thị cửa sổ <strong>Certificate Viewer</strong> tiếp đến bấm <strong>Show Certificate</strong> để xem chi tiết. Bấm <strong>OK</strong> để kết thúc",
  },

  acrobatReader: {
    step1: "<strong>Bước 1:</strong> Mở tệp dữ liệu PDF cần ký bằng Adobe Reader.",
    step2: "<strong>Bước 2:</strong> Chọn <strong>Use a certificate</strong> trong bảng <strong>All tools</strong>.",
    step3: "<strong>Bước 3:</strong> Chọn <strong>Digitally sign</strong>.",
    step4: "<strong>Bước 4:</strong> Đọc hướng dẫn sau đó bấm <strong>OK</strong> để tiếp tục.",
    step5: "<strong>Bước 5:</strong> Đưa con trỏ chuột vào vùng chứa PDF, nhấn giữ chuột trái để vẽ khung mong muốn hiển thị chữ ký.",
    step6: "<strong>Bước 6:</strong> Chọn CTS mong muốn ký.",
    step7: "<strong>Bước 7:</strong> Bấm <strong>Continue</strong> để sang bước tiếp theo",
    step8: "<strong>Bước 8:</strong> Cấu hình hiển thị thông tin chữ ký lại (nếu muốn)",
    step9: "<strong>Bước 9:</strong> Bấm <strong>Sign</strong> để bắt đầu ký",
    step10: "<strong>Bước 10:</strong> Màn hình đợi xác thực để ký. Vui lòng mở ứng dụng VneID để xác thực ký số.",

    step11: "<strong>Bước 11:</strong> Mở ứng dụng VNeID trên thiết bị di động.",
    step11a: "Vào mục <strong>Thông báo</strong> → Chọn <strong>Thông báo xác nhận yêu cầu ký số.</strong>",
    step11b: "Kiểm tra thông tin.",
    step11c: "Tích chọn nội dung đồng ý:",
    step11d: "“Tôi đã đọc và hiểu rõ nội dung mục đích (đã nêu ở trên); quyền và nghĩa vụ của chủ thể dữ liệu và đồng ý với các nội dung này.”",
    step11e: "Nhấn <strong>Xác nhận chia sẻ</strong>.",
    step11f: "Ứng dụng hiển thị <strong>Chia sẻ thông tin thành công.</strong>",

    step12: "<strong>Bước 12:</strong> Hoàn tất ký số",
    step12a: "Hệ thống GoPaperless Agent hiển thị thông báo: \n <strong>“Thực hiện ký thành công.”</strong>",

    step13: "<strong>Bước 13:</strong> Bấm 2 lần vào chữ ký để xem chi tiết CTS",
  },

  useCase: {
    title: "<strong>GoPaperless Agent</strong> không có giao diện người dùng (UI) riêng để ký, vì nó sử dụng giao diện của các ứng dụng gốc (native).",
    des: "Các trường hợp sử dụng phổ biến của <strong>GoPaperless Agent</strong> bao gồm:",
    word: "Ký bằng Microsoft Word",
    excel: "Ký bằng Microsoft Excel",
    ppt: "Ký bằng Microsoft PowerPoint",
    foxit: "Ký bằng Foxit Reader",
    acrobat: "Ký bằng Acrobat"
  },

  version1_26: {
    release: "<strong>Ghi chú phát hành</strong> – v1.26.3.18",
    date: "<strong>Ngày phát hành:</strong> 18/03/2026",
    environment: "<strong>Môi trường áp dụng:</strong> Chính thức",

    newFeatures: "<strong>Các tính năng mới:</strong>",
    newFeature1: "Hỗ trợ <strong>đăng nhập hệ thống (Login)</strong> với cơ chế xác thực nâng cao",
    newFeature2: "Tích hợp <strong>ký số trên Microsoft Office</strong> (Word, Excel, PowerPoint)",
    newFeature3: "Hỗ trợ ký số trên <strong>Foxit Reader</strong>",
    newFeature4: "Hỗ trợ ký số trên <strong>Adobe Reader</strong>",
    newFeature5: "Cho phép <strong>tạo chứng thư số (CTS) VNeID</strong> trực tiếp trên hệ thống",

    improve: "<strong>Cải tiến:</strong>",
    improve1: "Nâng cấp chức năng <strong>quản lý CTS VNeID</strong> giúp theo dõi và sử dụng chứng thư dễ dàng hơn",
    improve2: "Cải thiện hiệu năng và trải nghiệm người dùng trong quá trình ký số",
    improve3: "Tối ưu quy trình xử lý và đồng bộ dữ liệu",

    bugfix: "<strong>Sửa lỗi:</strong>",
    bugfix1: "Sửa một số lỗi nhỏ liên quan đến đăng nhập",
    bugfix2: "Sửa lỗi phát sinh trong quá trình ký số trên các nền tảng",
    bugfix3: "Cải thiện độ ổn định hệ thống"
  }
}

export default vi;
